import React from 'react';

import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const SelectBankScreen = ({ modalRef, primaryButtonOnClick }) => {
    const { leanPurpleBlock, leanGreyBlock, leanSubtitleInfoBlock, notNowButton, continueButton } = usePageMessages();
    return (
        <InfoPage
            dataTestId="select-bank-screen"
            insideModalComponent
            iconName="bank-building-card-thin"
            iconColor="primary"
            headerText={
                <>
                    <span className="color-GT">{leanPurpleBlock}</span>
                    {leanGreyBlock}
                </>
            }
            secondaryText={leanSubtitleInfoBlock}
            topButtonCaption={notNowButton}
            topButtonOnClick={() => modalRef?.current?.close()}
            primaryButtonCaption={continueButton}
            primaryButtonOnClick={primaryButtonOnClick}
        />
    );
};
export default SelectBankScreen;
